import { Outlet } from "react-router";

export function LabsRoute() {
  return <Outlet />;
}
